export default function toSeconds(ms) {
  const seconds = Math.ceil(ms/1000)

  if (seconds === 1) {
    return '1 second'
  } else {
    return `${seconds} seconds`
  }
}
